import React from 'react';
import styled from 'styled-components';
import CircularProgress from '@mui/material/CircularProgress';

export default function LoadingPage() {
  return (
    <LoaderContainer>
      <CircularProgress
        size={50} 
        disableShrink={true}
      />
    </LoaderContainer>
  );
}

const LoaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex: 1;
`;
